import { DynamicsContact } from "@/types/dynamics.types";

/** Server may return this when no CRM contact exists yet for the signed-in user. */
export const PLACEHOLDER_DYNAMICS_CONTACT_ID =
  "00000000-0000-0000-0000-000000000000";

export function hasEstablishedDynamicsContact(
  contact: DynamicsContact | null | undefined,
): boolean {
  if (!contact?.id) {
    return false;
  }
  return (
    contact.id.toLowerCase() !== PLACEHOLDER_DYNAMICS_CONTACT_ID.toLowerCase()
  );
}
